import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FLAGS } from "@/components/LanguageSwitcher";

export const isRivieraPath = (p) => p === "/fr" || p.startsWith("/fr/");

export default function CountrySwitcher({ compact = false, testid = "country-switcher-desktop" }) {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const active = isRivieraPath(pathname) ? "fr" : "nl";

  const pick = (code) => {
    if (code === "fr") {
      i18n.changeLanguage("fr");
      try { localStorage.setItem("trustline_lang", "fr"); } catch { /* ignore */ }
      if (active !== "fr") nav("/fr");
    } else if (active !== "nl") nav("/");
  };

  const opts = [
    { code: "nl", flag: "NL", label: t("country.nl") },
    { code: "fr", flag: "FR", label: t("country.fr") },
  ];

  return (
    <div role="group" aria-label={t("country.label")} data-testid={testid}
      className="inline-flex items-center rounded-full bg-slate-100 p-0.5 ring-1 ring-slate-200/80">
      {opts.map((o) => (
        <button key={o.code} type="button" onClick={() => pick(o.code)} aria-pressed={active === o.code}
          data-testid={`${testid}-${o.code}`}
          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 h-8 text-xs font-semibold transition-[background-color,color,box-shadow] duration-200 ${
            active === o.code ? "bg-white text-[#1B3A6B] shadow-sm" : "text-slate-500 hover:text-[#1B3A6B]"
          }`}>
          <span className="block w-4 h-4 rounded-full overflow-hidden ring-1 ring-black/10">{FLAGS[o.flag]}</span>
          {compact ? o.code.toUpperCase() : o.label}
        </button>
      ))}
    </div>
  );
}
